import { CompanyUserSummary } from '@treasury/domain/company/user/entities';
import { FiUser } from '@treasury/domain/users/fi-user.entity';
import { RowActionCommandResult } from '../../base.cmd';
import { CompanyUserActionType } from '../../company-users/user-actions.types';
import { FiUserActionType } from '../../fi-users/fi-user-actions.types';

export enum SharedUsersActionType {
    LegacyResetPassword = 'legacyResetPassword',
}

export class UserActionFlags {
    public isUisEnabled = false;

    public canResetUserPassword: boolean = false;
}

export type FiUserActionRecord = Record<
    FiUserActionType,
    RowActionCommandResult<FiUser, FiUserActionType>
>;

export type CompanyUserActionRecord = Record<
    CompanyUserActionType,
    RowActionCommandResult<CompanyUserSummary, CompanyUserActionType>
>;
export type SharedUsersActionRecord<T extends CompanyUserSummary | FiUser> = Record<
    SharedUsersActionType,
    RowActionCommandResult<T, SharedUsersActionType>
>;
